// 时间格式化工具
//
// 接受秒级 timestamp。tz 可选（后端 timezone 字段：北京=0、美西=15、UTC+1=7）。
// 不传 tz 时读全局 displayTimezone（详情页加载时同步），保持北京浏览器看北京设备一致行为。

import { displayTimezone, tzDate } from './utils/timezone.js'

function _tzd (sec, tz) {
  const offsetH = 8 - (Number.isFinite(Number(tz)) ? Number(tz) : (displayTimezone.value || 0))
  return new Date(Number(sec) * 1000 + offsetH * 3600 * 1000)
}

export function formatTime (d, tz) {
  // 获取年月日，时间
  const dat = _tzd(d, tz)
  const hour = dat.getUTCHours() < 10 ? '0' + (dat.getUTCHours()) : dat.getUTCHours();
  const min = dat.getUTCMinutes() < 10 ? '0' + (dat.getUTCMinutes()) : dat.getUTCMinutes();
  const seon = dat.getUTCSeconds() < 10 ? '0' + (dat.getUTCSeconds()) : dat.getUTCSeconds();
  let m = dat.getUTCMilliseconds();
  if (m < 10) m = '00' + m; else if (m < 100) m = '0' + m;
  return hour + ':' + min + ':' + seon + '.' + m;
}

export function formatDateTime (d, tz) {
  // 获取年月日，时间
  const dat = _tzd(d, tz)
  const year = dat.getUTCFullYear();
  let month = dat.getUTCMonth() + 1;
  if (month < 10) month = '0' + month;
  let day = dat.getUTCDate();
  if (day < 10) day = '0' + day;
  const hour = dat.getUTCHours() < 10 ? '0' + (dat.getUTCHours()) : dat.getUTCHours();
  const min = dat.getUTCMinutes() < 10 ? '0' + (dat.getUTCMinutes()) : dat.getUTCMinutes();
  const seon = dat.getUTCSeconds() < 10 ? '0' + (dat.getUTCSeconds()) : dat.getUTCSeconds();
  return year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + seon;
}

export function formatDateTime_full (d, tz) {
  // 获取年月日，时间
  const dat = _tzd(d, tz)
  const year = dat.getUTCFullYear();
  let month = dat.getUTCMonth() + 1;
  if (month < 10) month = '0' + month;
  let day = dat.getUTCDate();
  if (day < 10) day = '0' + day;
  const hour = dat.getUTCHours() < 10 ? '0' + (dat.getUTCHours()) : dat.getUTCHours();
  const min = dat.getUTCMinutes() < 10 ? '0' + (dat.getUTCMinutes()) : dat.getUTCMinutes();
  const seon = dat.getUTCSeconds() < 10 ? '0' + (dat.getUTCSeconds()) : dat.getUTCSeconds();
  let m = dat.getUTCMilliseconds();
  if (m < 10) m = '00' + m; else if (m < 100) m = '0' + m;
  return year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + seon + '.' + m;
}

// 注意：isToday 用于判断「今天」，应基于浏览器本地时间，不需要时区处理。
export function isToday (dstr) {
  const dat = new Date(dstr);
  const today = new Date();
  return dat.getFullYear() === today.getFullYear() && dat.getMonth() === today.getMonth() && dat.getDate() === today.getDate();
}

export function make_timestamp_from_hour (date, hour) {
  // 构造日期字符串，确保小时为两位数
  const datetimeString = `${date}T${hour.padStart(2, '0')}:00:00`;
  // 将字符串转换为 Date 对象并获取 Unix 时间戳（以秒为单位）
  const timestamp = Math.floor(new Date(datetimeString).getTime() / 1000);
  return timestamp;
}

export function formatTimeDiff (timeDiff) {
  if (isNaN(timeDiff)) {
    return '';
  }
  if (timeDiff < 60) {
    return `${Math.floor(timeDiff) + 1}秒前在线`;
  } else if (timeDiff < 3600) {
    return `${Math.floor(timeDiff / 60)}分钟前在线`;
  } else if (timeDiff < 86400) {
    return `${Math.floor(timeDiff / 3600)}小时前在线`;
  } else {
    return `${Math.floor(timeDiff / 86400)}天前在线`;
  }
}
export function getDateTimestamp (dstr) {
  return new Date(dstr).getTime() / 1000;
}

export function getHourTimestamp (timestampInSeconds) {
  if (!timestampInSeconds) {
    timestampInSeconds = new Date().getTime() / 1000;
  }
  const date = new Date(timestampInSeconds * 1000); // JavaScript 的 Date 对象是基于毫秒的
  date.setHours(date.getHours(), 0, 0, 0);
  return Math.floor(date.getTime() / 1000);
}
